module.exports = __webpack_public_path__ + "static/media/beauty3.1018b183.png";